/* eslint-disable */

import instance from './frontman';

export const postChargeStop = async (body: object, accessToken?: String) => {
    return await instance({
        url: "/stop",
        method: "post",
        data: body
    })
};